<template>
    <v-dialog
        :value="isOpen"
        scrollable
        max-width="500px"
        transition="slide-y-transition"
        eager
        @keydown.esc="onClose"
        @click:outside="onClose"
    >
        <v-card>
            <v-card-title>
                <h1 class="text-subtitle-1">
                    <template>
                        Numer wózka
                    </template>
                </h1>
            </v-card-title>

            <v-card-text class="text-center">
                <v-container fluid class="pa-0">
                    <v-row>
                        <v-col cols="12">
                            <v-text-field
                                v-model="trolleyNumber"
                                label="Numer"
                                type="trolleyNumber"
                                :error-messages="trolleyNumberErrors"
                                outlined
                                dense
                                required
                            />
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>

            <v-divider />

            <v-card-actions>
                <v-btn
                    color="error"
                    text
                    data-sentry-label="Anuluj"
                    :disabled="actionLoading"
                    @click="onClose"
                >
                    Anuluj
                </v-btn>
                <v-spacer />
                <v-btn
                    color="success"
                    text
                    data-sentry-label="Zapisz"
                    :loading="actionLoading"
                    @click="onSave"
                >
                    Wykonaj
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import { errorHandler } from '@/utils/errorHandler'

export default {
    name: 'TrolleyNumberDialog',
    props: {
        isOpen: {
            type: Boolean
        },
        plateData: {
            type: Object,
            default: null
        },
    },
    data() {
        return {
            plate: null,
            trolleyNumber: null,
            actionLoading: false
        }
    },
    validations() {
        return {
            trolleyNumber: {
                required
            },
        }
    },
    computed: {
        jobPlates() {
            return this.$store.state.prepress.prepressJobs.jobPlates
        },
        trolleyNumberErrors() {
            const errors = []

            if (!this.$v.trolleyNumber.$dirty) return errors
            !this.$v.trolleyNumber.required && errors.push('Numer wózka jest wymagany.')

            return errors
        }
    },
    watch: {
        isOpen(boolean) {
            if (boolean) {
                this.plate = JSON.parse(JSON.stringify(this.plateData))
            } else {
                this.$v.$reset()
                setTimeout(() => {
                    this.trolleyNumber = null
                    this.plate = null
                }, 500)
            }
        }
    },
    methods: {
        onSave() {
            this.$v.$touch()

            if (this.$v.$invalid) {
                this.$store.dispatch('showNotification', {
                    type: 'error',
                    message: this.$i18n.t('validations.invalidMessage')
                })

                return
            }

            const reportedJobPlates = this.jobPlates.filter(item => item.status === null)
            const getJobPlates = reportedJobPlates.length > 1

            this.actionLoading = true
            this.$store.dispatch('prepress/reportJobPlate', { plateId: this.plate.id, trolley: this.trolleyNumber })
                .then(() => {
                    if (getJobPlates) {
                        this.$emit('on-close', true)
                    } else {
                        this.$emit('on-close', false)
                    }
                })
                .catch(error => {
                    errorHandler(error)
                })
                .finally(() => {
                    this.actionLoading = false
                })
        },
        onClose() {
            this.$v.$reset()

            this.$emit('on-close', true)
        }
    }
}
</script>
